import React, { Component } from 'react'
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Navbar from '../Navbar/Navbar';
import DocumentsBody from './DocumentsBody';

class Documents extends Component {
  render() {
    return (
      <>
          <Navbar />
          <Header />
          <DocumentsBody />
          <Footer />
      </>
    )
  }
}
export default Documents;